<template>
    <div>
        <div class="row mb-2">
            <div class="col-4">
                <router-link :to="{name: 'componentCreate'}" class="btn btn-success btn-sm">{{$t('global.New')}}
                </router-link>
                <router-link :to="{name: 'componenttypeIndex'}" class="btn btn-primary btn-sm ml-2">
                    {{$t('component.Types')}}
                </router-link>
            </div>
            <div class="col-md-8">
                <button class="btn btn-outline-primary btn-sm pull-right">{{$t('global.Export')}}</button>
                <filter-global-input class="pull-right mr-2"/>
            </div>
        </div>
        <div class="card">
            <div class="card-body card-table">
                <vue-good-table
                        :columns="columns"
                        :isLoading.sync="isLoading"
                        :pagination-options="{
                            enabled: true,
                            nextLabel: $t('table.NextLabel'),
                            prevLabel: $t('table.PrevLabel'),
                            rowsPerPageLabel: $t('table.RowsPerPageLabel'),
                            ofLabel: $t('table.OfLabel'),
                            pageLabel: $t('table.PageLabel'),
                            allLabel: $t('table.AllLabel')
                        }"
                        :rows="table.rows"
                        :styleClass="'table'+((!isCLoading) ? ' table-hover' : '')"
                        :totalRows="table.totalRecords"
                        @on-column-filter="onColumnFilter"
                        @on-page-change="onPageChange"
                        @on-per-page-change="onPerPageChange"
                        @on-sort-change="onSortChange"
                        mode="remote">
                    <template slot="table-column" slot-scope="props">{{ $t('component.'+props.column.label) }}
                    </template>
                    <template slot="table-row" slot-scope="props">
                        <span v-if="props.column.field == 'interval_control'">
                            <span class="badge badge-info">{{props.row.interval_control}} months</span>
                        </span>
                        <span v-else-if="props.column.field == 'status'">
                            <span class="badge badge-info">
                            <span v-if="props.row.status == 1">Active</span>
                            <span v-else>Inactive</span>
                            </span>
                        </span>
                        <span v-else>
                  {{props.formattedRow[props.column.field]}}
                </span>
                        <span v-if="props.column.field == 'actions'">
                          <router-link :to="{name: 'componentView', params: {id: props.row.id, customer_id: props.row.customer_id}}" class="btn btn-sm btn-primary"><i class="fa fa-bar-chart"></i></router-link>
                        </span>
                    </template>
                    <div slot="emptystate">
                        <span v-if="isCLoading">
                            <loader-table></loader-table>
                        </span>
                        <span v-else>
                            {{$t('table.NoData')}}
                        </span>
                    </div>
                    <template slot="loadingContent">
                        <div class="spinner-border text-secondary" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </template>
                </vue-good-table>
            </div>
        </div>
    </div>
</template>
<script>
    import 'vue-good-table/dist/vue-good-table.css'
    import {VueGoodTable} from 'vue-good-table'
    import {mapActions, mapGetters} from 'vuex'
    import loaderTable from '@/components/charts/loaders/loader-table.vue'
    import FilterGlobalInput from '@/components/FilterGlobalInput'

    export default {
        name: 'componentIndex',
        data() {
            return {
                isLoading: false,
                isCLoading: true,
                columns: [
                    {
                        label: 'PacketNumber',
                        field: 'packet_number',
                    },
                    {
                        label: 'Number',
                        field: 'number',
                    },
                    {
                        label: 'Customer',
                        field: 'relations.customer.name',
                    },
                    {
                        label: 'Type',
                        field: 'relations.type.name',
                    },
                    {
                        label: 'Brand',
                        field: 'relations.brand.name',
                    },
                    {
                        label: 'IntervalControl',
                        field: 'interval_control',
                    },
                    {
                        label: 'Status',
                        field: 'status',
                    },
                    {
                        label: 'Actions',
                        field: 'actions',
                        sortable: false,
                    }
                ],
            };
        },
        computed: mapGetters({
                table: 'TABLE'
            }
        ),
        components: {
            VueGoodTable,
            loaderTable,
            FilterGlobalInput
        },
        async mounted() {
            this.$store.dispatch('TO_DEFAULTSTATE')
            await this.loadItems()
            this.isCLoading = false
        },
        methods: {
            ...mapActions({
                    loadItems: 'GET_COMPONENTS',
                }
            ),
            updateParams(newProps) {
                this.$store.dispatch('CHANGE_SERVERPARAMS', newProps)
            },

            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                this.loadItems();
            },

            onPerPageChange(params) {
                this.updateParams({perPage: params.currentPerPage});
                this.loadItems();
            },

            onSortChange(params) {
                let type = params[0].type
                let field = params[0].field

                switch (field) {
                    case 'relations.type.interval_control':
                        field = 'interval_control'
                        break
                    case 'relations.customer.name':
                        field = 'name'
                        break
                    case 'relations.type.name':
                        field = 'type_name'
                        break
                    case 'relations.brand.name':
                        field = 'brand'
                        break
                }

                this.updateParams({
                    sort: [{
                        type: type,
                        field: field,
                    }],
                });
                this.loadItems();
            },
            onColumnFilter(params) {
                this.updateParams(params);
                this.loadItems();
            },
        }
    }
</script>
<style>
    #bar-chart{
        width: 100%;
    }
</style>
